export default "__VITE_ASSET__xHhsjJuw__"